import { useQuerySession } from "../session";

export const useUserId = () => {
  const { data: session } = useQuerySession({
    retryOnMount: false
  });
  return session?.userId as string;
};
